/**
 * Created by Abner Sui on 01/22/2019.
 * Description:
 *
 * ------ maintenance history ------
 * 05/01/2019 Yoyo make it support smart reducers.
 * 05/07/2019 Yoyo add action to clear current shown item
 * 08/19/2019 add track by function for ng if
 */

import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { StoreQuerierService } from '../../services/store-querier.service';
import { AppState, smartSelector } from '../../redux';
import { BlastEmailDetailConfig, BlastEmailDetailActions } from './blastemail-detail.view-model';

import { BlastEmail } from '../../tamalelibs/models/blastemail.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AttachmentView } from '../attachment-list/attachment-view.model';
import { DocumentEmail } from '../../tamalelibs/models/document-email.model';
import { CREATE_NOTE_SUCCESS } from '../../tamalelibs/redux/note.actions';
import { filter, take } from 'rxjs/operators';
import { AlertButton, AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { BlastEmailViewBlastEmailListDelete, BlastEmailViewGetBlastEmailBody } from '../../redux/actions/blastemail-view.actions';
import { getActiveBlastEmailState, getBlastEmailListMatchedAttachmentState } from '../../redux/reducers/blastemail-view.reducer';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { ThreadDetailService } from '../../services/thread-detail.service';
import { SlideSheetActionTypes } from '../slide-sheet/slide-sheet.model';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { businessConstants } from '../../tamalelibs/constants/business.constants';
import { BlastEmailService } from '../../tamalelibs/services/blastemail.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { ToastService } from './../../widgets/toast/toast.service';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'blastemail-detail',
    templateUrl: './blastemail-detail.component.html',
    styleUrls: ['./blastemail-detail.component.scss']
})
export class BlastEmailDetailComponent implements OnInit, OnDestroy {
    @Input() config: BlastEmailDetailConfig;
    @ViewChild('contentBox', { static: false }) contentBoxEle: ElementRef;
    @Output() public quickDeposit = new EventEmitter<BlastEmail>();
    @Output() public normalDeposit = new EventEmitter<BlastEmail>();
    @Output() public quickAddContact = new EventEmitter<BlastEmail>();
    @Output() public AddContact = new EventEmitter<BlastEmail>();

    attachmentViewModelList: Array<AttachmentView> = [];
    isIPAD = false;
    isNoData = true;
    isShowMaximun = false;
    keywords: string[] = [];
    blastEmail: BlastEmail;
    showBlastEmailBody = true;
    canAddContactFast = false;
    canDepositFast = false;
    renderHighlight = false;

    private _destroySubscriptions: Array<Subscription> = [];
    private _templateMsgSubscription$: Subscription; // app state for template action messages
    constructor(
        private _store: Store<AppState>,
        private _storeQuerier: StoreQuerierService,
        private _deviceService: DeviceDetectorService,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _alertWindow: AlertWindowService,
        private _threadDetailService: ThreadDetailService,
        private _slideSheetService: SlideSheetService,
        private _blastEmailService: BlastEmailService,
        private _toastService: ToastService,
    ) {
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
    }

    ngOnInit() {
        this.initComponent();
    }

    ngOnDestroy() {
        this.destroyComponent();
    }

    clickFastDepositNote() {
        this.quickDeposit.emit(this.blastEmail);
    }

    clickDepositNote() {
        this.normalDeposit.emit(this.blastEmail);
    }

    clickFastAddContact() {
        this._blastEmailService.getBlastEmailById(this.blastEmail.id).pipe(take(1)).subscribe(res => {
            if (res['details'] && res['details'].hasOwnProperty('contact')) {
                this._toastService.notify({
                    message: 'This contact has existed, please refresh',
                    style: NotificationStyles.Info
                });
            } else {
                this.quickAddContact.emit(this.blastEmail);
            }
        });
    }

    delete() {
        const content: string[] = [];
        content.push('Are you sure you want to delete this blast email?');
        content.push('Any attachments will be deleted.');
        const cancelBtn: AlertButton = {
            text: 'Cancel',
            type: AlertBtnTypes.tertiary
        };
        const confirmButton: AlertButton = {
            text: 'Delete',
            type: AlertBtnTypes.destructive
        };
        const subscription = this._alertWindow.
            custom('Delete confirmation required', content, cancelBtn, confirmButton)
            .subscribe((result: boolean) => {
                if (result) {
                    this._store.dispatch(new BlastEmailViewBlastEmailListDelete(
                        {
                            id: this.blastEmail.id,
                            componentId: 'blast email detail',
                        },
                        this.config.prefix,
                        this.config.instanceId,
                    ));
                }
                subscription.unsubscribe();
            });
    }

    destroyComponent() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._templateMsgSubscription$.unsubscribe();
    }

    getEntityTagHref(item): string {
        if (item && item['type']) {
            if (item['type']['name'] === 'Contact') {
                return 'contact/' + item.id;
            } else {
                return 'entity/' + item.id;
            }
        }
        return null;
    }

    initComponent() {
        this._destroySubscriptions.push(
            this._store.pipe(
                select(this._relativeSelector(getActiveBlastEmailState))
            ).subscribe(data => this._onSubscribeBlastEmailData(data))
        );

        this._destroySubscriptions.push(
            this.config.actions$.subscribe(action => this._onSubscribeActions(action))
        );
        this._templateMsgSubscription$ = this._noteTemplatePageViewModel.templateMsg().pipe(
            filter(res => res != null && res.length > 0))
            .subscribe(res => this._takeTemplateMsg(res));
    }

    isEntityTagHighlight(shortName: string) {
        if (this.keywords.length === 0) {
            return false;
        }

        for (let index = 0; index < this.keywords.length; index++) {
            if (shortName.toLowerCase() === this.keywords[index].toLowerCase()) {
                return true;
            }
        }

        return false;
    }

    onAddContactClick() {
        this._blastEmailService.getBlastEmailById(this.blastEmail.id).pipe(take(1)).subscribe(res => {
            if (res['details'] && res['details'].hasOwnProperty('contact')) {
                this._toastService.notify({
                    message: 'This contact has existed, please refresh',
                    style: NotificationStyles.Info
                });
            } else {
                this.AddContact.emit(this.blastEmail);
            }
        });
    }

    onClickTag(item, event: Event) {
        // prevent a.href auto redirect
        event.preventDefault();
        event.stopPropagation();
        if (item && item['type']) {
            this._openEntityByIdAndType(item['type']['name'], item.id);
        }
    }

    onToggle() {
        this.showBlastEmailBody = !this.showBlastEmailBody;
    }

    onKeyup(event) {
        if (this.isShowMaximun && event.keyCode === 27) {
            this.onMaximumClick();
        }
    }

    onMaximumClick() {
        this.isShowMaximun = !this.isShowMaximun;
    }

    @HostListener('window:keyup', ['$event'])
    onkeyup(event) {
        if (event.keyCode === 27) {
            this.isShowMaximun = false;
        }

    }

    trackByFn(index, item) {
        return item.id;
    }

    private _relativeSelector(selector) {
        return (state) => {
            return selector(smartSelector(this.config.instanceId, 'blastEmailReducer')(state));
        };
    }

    private _onSubscribeActions(action) {
        if (action.type === BlastEmailDetailActions.TOGGLE_MAXIMIZE) {
            this.isShowMaximun = action.payload;
        } else if (action.type === BlastEmailDetailActions.CLEAR) {
            this.isNoData = true;
        }
    }

    private _onSubscribeBlastEmailData(blastEmail) {
        this.attachmentViewModelList = [];
        this.keywords = [];
        if (blastEmail) {
            if (this.contentBoxEle) {
                this.contentBoxEle.nativeElement.scrollTop = 0;
            }
            this.blastEmail = blastEmail;
            // check if body are loaded
            const bodyLoaded: boolean = !!this.blastEmail.body;
            if (bodyLoaded === false) {
                this._store.dispatch(new BlastEmailViewGetBlastEmailBody(
                    this.blastEmail,
                    this.config.prefix,
                    this.config.instanceId
                ));
            }
            if (!this.config.singlePageMode && this.config.keywordStoreSelector) {
                // process keyword against lucence special characters
                const keyword: string = this._storeQuerier.queryBySelector(this._relativeSelector(this.config.keywordStoreSelector));
                if (keyword) {
                    this.keywords = this._threadDetailService.parseKeywordsFromSearchString(keyword);
                } else {
                    this.keywords = [];
                }
            }
            const matchedAttachmentIdSet: Set<string> = this._storeQuerier.queryBySelector(this._relativeSelector(getBlastEmailListMatchedAttachmentState));
            if (this.blastEmail.attachments && this.blastEmail.attachments.size > 0) {
                Array.from(this.blastEmail.attachments.values()).forEach((item: DocumentEmail) => {
                    const attachment = AttachmentView.parseFromDocumentEmail(item);
                    attachment.highlight = matchedAttachmentIdSet && matchedAttachmentIdSet.has(item.id);
                    this.attachmentViewModelList.push(attachment);
                });
            }
            this.canAddContactFast = !this.blastEmail.contact && !this.blastEmail.fromPersonNameDuplicate;
            const hasValidEntity: boolean = this.blastEmail.entities.length > 1 || ![businessConstants.entity.Uncategorized_Fixed_ID, businessConstants.entity.UnSpecified_Fixed_ID].includes(this.blastEmail.entities[0].id);
            this.canDepositFast = hasValidEntity && !!this.blastEmail.contact;
            this.isNoData = false;
        } else {
            this.isNoData = true;
        }
        // MarkJS strange behavior, we have to re-render highlight area
        this.renderHighlight = false;
        setTimeout(() => {
            this.renderHighlight = true;
        });
    }

    private _openEntityByIdAndType(name, id): void {
        if (name === 'Contact') {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.CONTACT_PANEL,
                payload: id
            });
        } else {
            this._slideSheetService.slideSheetActionSubject$.next({
                type: SlideSheetActionTypes.ENTITY_PANEL,
                payload: id
            });
        }
    }

    private _takeTemplateMsg(msg) {
        if (msg === CREATE_NOTE_SUCCESS) {
            this.isShowMaximun = false;
        }
    }

}
